import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg-S4-logo_svg__Layer_1",
  "data-name": "Layer 1",
  viewBox: "0 0 47 56.4"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(".svg-S4-logo_svg__cls-2,.svg-S4-logo_svg__cls-3{fill-rule:evenodd}.svg-S4-logo_svg__cls-2{fill:#3abcda}.svg-S4-logo_svg__cls-3{fill:#042c5c}", -1)
        ]))]),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<path d=\"M17.78 8.38 28.2 18.8 22 40.62l-7.9-7.75L9.4 14.1l8.38-5.72Z\" style=\"fill:#007ab3;fill-rule:evenodd;\"></path><path d=\"M35.25 35.25H47l-9.4 8.62L22 40.63l13.25-5.37Z\" style=\"fill:#007ab3;\"></path><path d=\"m37.6 43.87-14.1 3.86L7.05 56.4 22 40.62l15.6 3.24Z\" style=\"fill:#042c5c;\"></path><path d=\"M14.1 48.96 0 51.7l7.05 4.7 7.05-7.44Z\" class=\"svg-S4-logo_svg__cls-2\"></path><path d=\"M35.25 35.25H47l-5.96-2.35-5.79 2.35ZM44.94 37.14 47 39.2v-3.95l-2.06 1.89Z\" class=\"svg-S4-logo_svg__cls-3\"></path><path d=\"M35.25 35.25 28.2 18.8 22 40.62l13.25-5.37Z\" class=\"svg-S4-logo_svg__cls-2\"></path><path d=\"m9.4 14.1 2.35-11.75L2.35 0 9.4 14.1Z\" class=\"svg-S4-logo_svg__cls-3\"></path><path d=\"m17.78 8.38-6.03-6.03L9.4 14.1l8.38-5.72Z\" class=\"svg-S4-logo_svg__cls-2\"></path>", 8))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "S4-logo"}) } }